/* ============================================================
   FORMABOX — interactions
   Progressive enhancement only: every page works without JS.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Focus trap helper (shared with consent.js) ----- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]),' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  window.FB = window.FB || {};

  window.FB.trapFocus = function (container, onEscape) {
    function onKey(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        container.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function release() { container.removeEventListener('keydown', onKey); };
  };

  window.FB.toast = function (message) {
    var region = document.getElementById('toast-region');
    if (!region) return;
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = message;
    region.appendChild(el);
    setTimeout(function () { el.remove(); }, 4500);
  };

  /* ---------- Footer year ------------------------------------ */
  var yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = String(new Date().getFullYear());

  /* ---------- Price range output ------------------------------ */
  var range = document.getElementById('price-range');
  var rangeOut = document.getElementById('price-out');
  if (range && rangeOut) {
    range.addEventListener('input', function () { rangeOut.textContent = '$' + Number(range.value).toLocaleString('en-CA'); });
  }

  /* ---------- Mobile menu ------------------------------------ */
  var burger = document.querySelector('[data-menu-open]');
  var panel = document.getElementById('mobile-menu');
  if (burger && panel) {
    var releaseMenu = null;
    var closeBtn = panel.querySelector('[data-menu-close]');

    function openMenu() {
      panel.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      (closeBtn || panel.querySelector(FOCUSABLE)).focus();
      releaseMenu = window.FB.trapFocus(panel, closeMenu);
    }
    function closeMenu() {
      panel.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (releaseMenu) { releaseMenu(); releaseMenu = null; }
      burger.focus();
    }
    burger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    panel.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') closeMenu();
    });
  }

  /* ---------- Accordions ------------------------------------- */
  document.querySelectorAll('.accordion__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var panelEl = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(!expanded));
      if (panelEl) panelEl.hidden = expanded;
    });
  });

  /* ---------- Segmented controls (billing period) ------------ */
  document.querySelectorAll('[data-segmented]').forEach(function (group) {
    var buttons = group.querySelectorAll('button');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var period = btn.dataset.period;
        document.querySelectorAll('[data-price-monthly]').forEach(function (el) {
          el.textContent = period === 'yearly' ? el.dataset.priceYearly : el.dataset.priceMonthly;
        });
        document.querySelectorAll('[data-cycle]').forEach(function (el) {
          el.textContent = period === 'yearly' ? '/ mois' : '/ mois';
        });
        document.querySelectorAll('[data-billing-note]').forEach(function (el) {
          el.textContent = period === 'yearly' ? el.dataset.noteYearly : el.dataset.noteMonthly;
        });
      });
      // Arrow-key navigation between the two options
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var list = Array.prototype.slice.call(buttons);
        var i = list.indexOf(btn);
        var next = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
        next.focus(); next.click();
      });
    });
  });

  /* ---------- Tabs -------------------------------------------- */
  document.querySelectorAll('[role="tablist"]').forEach(function (list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      tab.focus();
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') { e.preventDefault(); select(tabs[(i + 1) % tabs.length]); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); select(tabs[(i - 1 + tabs.length) % tabs.length]); }
        if (e.key === 'Home')       { e.preventDefault(); select(tabs[0]); }
        if (e.key === 'End')        { e.preventDefault(); select(tabs[tabs.length - 1]); }
      });
    });
  });

  /* ---------- Reveal on scroll -------------------------------- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.reveal');
  function revealAll() { targets.forEach(function (el) { el.classList.add('is-in'); }); }

  if (reduce || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    var reported = false;
    var io = new IntersectionObserver(function (entries) {
      reported = true;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (el) { io.observe(el); });

    // Failsafe. An observer in a hidden, prerendered or occluded tab may
    // never report; content must never be left permanently invisible.
    setTimeout(function () { if (!reported) revealAll(); }, 1200);
  }

  /* ---------- Checkout: required consent gates the button ----- */
  var checkoutForm = document.getElementById('checkout-form');
  if (checkoutForm) {
    var submit = checkoutForm.querySelector('[data-submit]');
    var required = checkoutForm.querySelectorAll('input[type="checkbox"][required]');
    function sync() {
      var ok = Array.prototype.every.call(required, function (c) { return c.checked; });
      submit.disabled = !ok;
      submit.setAttribute('aria-disabled', String(!ok));
    }
    required.forEach(function (c) { c.addEventListener('change', sync); });
    sync();
  }
})();
